import { SelectProps, Select, OutlinedInput } from '@mui/material';
import { styled } from '@mui/system';

const StyledSelect = styled(Select)<SelectProps>(() => {
  return ({
    backgroundColor: 'background.secondary', color: 'text.primary',
    border: '1px solid', borderColor: 'background.border',
    minWidth: '4rem',
    maxHeight: '2rem',
    margin: '0rem 0.5rem',
  })
}
)

const AppliedStyle = (props: SelectProps) => {
  return <StyledSelect {...props} input={<OutlinedInput />}>
    {props.children}
  </StyledSelect>
}

export default AppliedStyle